import React from "react";
import email from "../../assets/email.svg";
import call from "../../assets/call.svg";

function Contact() {
  return (
    <div className="md:mt-[-80px] mt-[0] md:w-[70vw] w-[100vw]   px-[20px] md:px-0 bg-[#FCFCF6] py-[50px] md:py-[108px] md:pl-[96px] relative z-[5] h-screen">
      <div className="flex flex-col md:text-base text-sm gap-4 md:gap-10">
        <div>
          <h2 className="font-bold">Send us an Email</h2>
          <div className="flex items-center gap-4 pl-[10px] md:pl-[40px] w-full md:w-[558px] h-[40px] md:h-[60px] bg-white rounded-sm md:rounded-lg">
            <img src={email} alt="" className="w-[15px] md:w-auto" />
            <p>tyrionexchange24@gmail.com</p>
          </div>
        </div>
        <div>
          <h2 className="font-bold">Call/WhatsApp</h2>
          <div className="flex items-center gap-4 pl-[10px] md:pl-[40px] w-full md:w-[558px] h-[40px] md:h-[60px] bg-white rounded-sm md:rounded-lg">
            <img src={call} alt="" className="w-[15px] md:w-auto" />
            <p>09049013384</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
